import { z } from 'zod'
import { zId, zIdNullable, zIsoDate } from '../common'
import { zTopicIntent, zTopicKind, zTopicTemplate } from '../enums'

export const zTopicListItem = z.object({
  id: zId,
  tenantId: zId,
  // Real API allows null (incomplete/legacy topics); form still requires it on write.
  keyword: z.string().nullable(),
  title: z.string(),
  targetWordCount: z.number().nullable(),
  template: zTopicTemplate.nullable(),
  kind: zTopicKind,
  // Marketing-funnel intent + 0..100 commercial score, set server-side by the
  // research pipeline. Defaulted for forward-compat with older payloads.
  intent: zTopicIntent.default('informational'),
  commercialScore: z.number().default(0),
  parentId: zIdNullable,
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type TopicListItem = z.infer<typeof zTopicListItem>

export const zTopicDetail = zTopicListItem.extend({
  brief: z.string().nullable(),
})
export type TopicDetail = z.infer<typeof zTopicDetail>

export interface TopicClusterNode extends TopicListItem {
  children: TopicClusterNode[]
}

export const zTopicClusterNode: z.ZodType<TopicClusterNode, z.ZodTypeDef, unknown> = z.lazy(() =>
  zTopicListItem.extend({
    children: z.array(zTopicClusterNode),
  }),
)
